/**
 * Type of statistical value.
 * tag: 2479
 * @readonly
 * @enum {number} (int)
 */
export enum MDStatisticValueType {
  /** Absolute */
  Absolute = 1,
  /** Percentage */
  Percentage = 2,
}
